import { render } from "./QuestionTypeSelector.vue?vue&type=template&id=26f94036&scoped=true&ts=true"
import script from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"
export * from "./QuestionTypeSelector.vue?vue&type=script&lang=ts"

import "./QuestionTypeSelector.vue?vue&type=style&index=0&id=26f94036&lang=sass&scoped=true"

import exportComponent from "/builds/sgumanea/ciena/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f94036"]])

export default __exports__